import React, { useEffect, useState, useCallback } from "react";
import PortalRoleForm from "./PortalRoleForm";
import ObjectList from "../../../Common/ObjectList";
import ObjectListMobile from "../../../Common/ObjectListMobile";
import http from "../../../Common/RestAPIHandler";
import {portalUser} from "../../../Common/Languages";

const lang = localStorage.getItem("languages");

const tableColumns = [
  {
    id: "role_name",
    label: portalUser.ROLENAME[lang],
    minWidth: 150,
    sortable: true,
  },
  {
    id: "description",
    label: portalUser.ROLEDESCRIPTION[lang],
    minWidth: 220,
    sortable: true,
  },
  {
    id: "status",
    label: portalUser.STATUS[lang],
    minWidth: 100,
    sortable: true,
  },
  {
    id: "user_count",
    label: portalUser.USERCOUNT[lang],
    minWidth: 100,
    sortable: true,
  },
  {
    id: "created_by_name",
    label: portalUser.CREATEDBY[lang],
    minWidth: 150,
    sortable: true,
  },
];

const PortalRoleList = (props) => {
  const [data, setData] = useState([]);
  const [loadData, setLoadData] = useState(false);
  const url = `portal-roles`;
  const actions = {
    delete: true,
    importCSV: false,
    exportCSV: false,
    exportPDF: false,
  };

  const fetchData = useCallback(() => {
    setLoadData(true);
    http.Get(
      url,
      (data) => {
        data.forEach(
          (item) => {
            item.rp_disabled = !item.status;
            item.status = item.status ? "Active" : "Disabled";
          }
        );
        setData(data);
        setLoadData(false);
      },
      () => {
        setLoadData(false);
      }
    );
  }, [url]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return (
    <>
    {!props.mobile && 
    <ObjectList
      {...props}
      moduleName={portalUser.PortalSecurityControl[lang]}
      url={url}
      actions={actions}
      permissions={{
        create: ["Manage Portal Users"],
        edit: ["Manage Portal Users"],
        delete: ["Manage Portal Users"],
      }}
      tableColumns={tableColumns}
      data={data}
      fetchData={fetchData}
      objectForm={PortalRoleForm}
      orderBy={"role_name"}
      searchFields={["role_name"]}
      pageHeader={(props.user.company_name || "") + " | Portal Management"}
      loadData={loadData}
    />
    }
    {props.mobile && 
    <ObjectListMobile
      {...props}
      moduleName={"Portal Security Control"}
      url={url}
      actions={actions}
      permissions={{
        create: ["Manage Portal Users"],
        edit: ["Manage Portal Users"],
        delete: ["Manage Portal Users"],
      }}
      tableColumns={tableColumns}
      data={data}
      fetchData={fetchData}
      objectForm={PortalRoleForm}
      orderBy={"role_name"}
      searchFields={["role_name"]}
      pageHeader={(props.user.company_name || "") + " | Portal Management"}
      loadData={loadData}
    />
    }
    </>
  );
};

export default PortalRoleList;
